import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { LoadingService } from 'src/app/_services/loading.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { Title } from '@angular/platform-browser';
import { ColorService } from '../../_ecomservices/color.service';
import { ProductService } from '../../_ecomservices/product.service';
import { DialogService } from 'src/app/_services/dialog.service';

@Component({
  selector: 'app-product-colors',
  templateUrl: './product-colors.component.html',
  styleUrls: ['./product-colors.component.css']
})
export class ProductColorsComponent implements OnInit {

  colorDisplayedColumns: string[] = ['ColorName', 'ColorCode', 'Action'];
  colorsDataSource: MatTableDataSource<any>;

  constructor(public colorService: ColorService,
    private dialog: MatDialog,
    private titleService: Title,
    private loading: LoadingService,
    private notificationService: NotificationService,
    public dialogService: DialogService,
    public productService: ProductService) { }

  ngOnInit() {
    this.titleService.setTitle('Product Color');
    this.onLoadColors();
  }

  onCreateColor() {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "35%";
    matDialogConfig.position = { top: '10px' }
    this.dialog.open(CreateColorComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.onLoadColors();
    });
  }

  onLoadColors() {
    var result = this.colorService.get_all_colors().subscribe(data => {
      if (data['status']) {
        this.colorsDataSource = new MatTableDataSource<any>(data['colors']);
      }
    });
  }

  toggleColorStatusChange(event: any, colorId: number) {
    let checked = event.checked;
    let status = 0;
    if(checked){
      status = 1;
    }
    this.colorService.update_color_status(colorId, status).subscribe(data => {
      // console.log(data);
    });
  }

  onEditColor(rowData: any) {
    this.colorService.populateForm(rowData);
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "30%";
    matDialogConfig.position = { top: '10px' };
    this.dialog.open(CreateColorComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.onLoadColors();
    });
  }

  onDeleteColor(color: any) {
    this.dialogService.openConfirmDialog('Are you sure want to delete this color?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.loading.spin$.next(true);
          this.colorService.delete_color(color.id).subscribe(data => {
            if (data['status']) {
              this.notificationService.success(data['message']);
              this.onLoadColors();
              this.loading.spin$.next(false);
            }
            else {
              this.notificationService.error('Product color could not be deleted, Try Again!');
              this.loading.spin$.next(false);
            }
          });
        }
      });
  }

}



/* Create Color */
@Component({
  selector: 'create-color-dialog',
  templateUrl: 'create-color-dialog.html',
})
export class CreateColorComponent {

  constructor(
    private dialogRef: MatDialogRef<ProductColorsComponent>,
    public colorService: ColorService,
    private loading: LoadingService,
    private notificationService: NotificationService,
    public dialogService: DialogService,
  ) {
  }


  onColorAddedFormSubmit(formData: any) {
    if (this.colorService.color_form.valid) {
      this.loading.spin$.next(true);
      if (!this.colorService.color_form.controls['id'].value) {
        // Insert Data
        this.colorService.insert_color(formData).subscribe(data => {
          if (data['status']) {
            this.notificationService.success(data['message']);
            this.onClose();
            this.loading.spin$.next(false);
          }
          else {
            this.notificationService.error(data['message']);
            this.loading.spin$.next(false);
          }
        });
      }
      else {
        // Update Data
        this.colorService.update_color(formData).subscribe(data => {
          if (data['status']) {
            this.notificationService.success('Color updated Successfully.');
            this.onClose();
            this.loading.spin$.next(false);
          }
          else {
            this.notificationService.error(data['message']);
            this.loading.spin$.next(false);
          }
        });
      }
    }
  }







  onClose() {
    // console.log('Close');
    this.colorService.color_form.reset();
    this.dialogRef.close();
  }

}


